<template>
  <div class="outer-wrapper">
      <div class="title">
        <p>图纸管理</p>
    </div>
    <Tabs>
      <TabPane label="全部图纸" icon="logo-buffer">
        <query-list
          :columnsFormatData="columnsFormatData"
          :askData="askData"
          :refreshData="update_count"
          main_width="1280px"
        ></query-list>
      </TabPane>
      <Button @click="openModal('newCreate')" slot="extra" type="primary">新增图纸</Button>
    </Tabs>
    <Modal
      v-model="modalValue.newCreate"
      :width="600"
      :mask-closable="false"
      :closable="false"
    >
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>新建图纸</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>图纸名称：</td>
              <td>
                <input
                  type="text"
                  placeholder="图纸名称"
                  v-model="item.name"
                  style="width:400px;"
                />
              </td>
            </tr>
            <tr>
              <td>图纸编号：</td>
              <td>
                <input
                  type="text"
                  placeholder="图纸代码"
                  v-model="item.draw_no"
                  style="width:400px;"
                />
              </td>
            </tr>
            <tr>
              <td>请选择对应流程：</td>
              <td>
                <select name="" id="" v-model="item.default_workflow_id">
                  <option :value="t.id" v-for="(t,i) in workflowList" :key="i">{{t.name}}</option>
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="newCreateSubmit('newCreate')"  >提交</Button>
        <Button size="large" @click="closeModal('newCreate')" >取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import queryList from "@/components/Common/QueryList.vue";
let userToken = localStorage.getItem("current_user_token");
//import shellExpand from "./ShellExpand.vue";

function itemFac(){
  return {
    name:"",
    draw_no:"",
    default_workflow_id:0
  };
}


export default {
  name: "workflowManage",
  props: [],
  components: {
    queryList
  },
  data() {
    return {
      op_name: this.$options.name,
      askData: "workflowList",
      update_count: 0,
      modalValue:{
          newCreate:false,
      },
      item:itemFac(),
      workflowList:[],
      columnsFormatData: [
        {
          title: "图纸名称",
          key: "name",
          align: "center"
        },
        {
          title: "图纸编号",
          key: "draw_no",
          align: "center"
        },
        {
          title: "对应流程",
          key: "draw_no",
          align: "center"
        },
        {
          title: "创建时间",
          key: "record_time",
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red",marginRight:'5px' },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              ),
              
            ]);
          }
        }
        
      ]
    };
  },
  computed:{

  },
  created(){
    this.getOptionsData();
  },
  methods: {
    getOptionsData(){
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: 'workflowOption',
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.workflowList = response.data.res_record;
          }else{
            this.$Message.warning('请求选项数据失败！');
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    openModal(value){
        this.modalValue[value] = true;
    },
    closeModal(value){
        this.modalValue[value] = false;
    },
    confirmBox(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content:
          "<p>" +
          "图纸：" +
          value.name +          
          "</p>",
        onOk: () => {
          this.recordFormatDel(value.id);
        },
        onCancel: () => {}
      });
    },
    recordFormatDel(id) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delDraw",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    newCreateSubmit(value){
      let form = new FormData();
        form.append("userToken", userToken);
        form.append("item", JSON.stringify(this.item));
        form.append("askData", "createDraw");
        let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
        this.$axios
          .post(this.$url + "/process", form, config)
          .then(response => {
            if (response.data.stat === "ok") {
              this.$Message.success("新建成功！");
              this.update_count++;
              this.closeModal(value);
            } else {
              this.$Message.error(response.data.info);
            }
          })
          .catch(error => {
            this.$Message.error(error + "未知错误！");
          });
    },
  }
};
</script>
<style scoped>
.outer-wrapper{
    width:1280px;
    margin:0 auto;
}
.title{
  text-align: center;
  margin:10px auto;
  font-size:20px;

}
.cr-form{
    width:100%;
    border-collapse: collapse;
}

.cr-form td{
    height:45px;
}

.cr-form td:first-child{
    text-align: right;
}

.cr-form input{
    padding: 0 10px;
    outline: none;
    height:30px;
    border-radius: 2px;
    border:1px solid #aaa;
}
</style>